import { render, staticRenderFns } from "./ColumnCategoryTranslatedName.vue?vue&type=template&id=b9b1cb10"
import script from "./ColumnCategoryTranslatedName.vue?vue&type=script&lang=js"
export * from "./ColumnCategoryTranslatedName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports